import React__default from 'react';
import Box from '../../components/Box/Box.js';

/**
 * This is a stub. Dependent on an inline-editable text field.
 */

const ActionTitle = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(Box, null, children);
};
ActionTitle.displayName = "ActionTitle";
var ActionTitle$1 = ActionTitle;

export { ActionTitle$1 as default };
